import { set } from "lodash";
import { useEffect, useState } from "react";
import { InlineCode } from "./inline_code";

export function CopyableText(props: { text: string; is_disabled?: boolean }) {
	const [show_copied, setShowCopied] = useState(false);

	return (
		<button
			className="inline-flex items-center gap-2 hover:text-sesh-primary"
			onClick={() => {
				if (props.is_disabled) return;

				setShowCopied(true);
				setTimeout(() => setShowCopied(false), 1000);
				navigator.clipboard.writeText(props.text);
			}}
		>
			<InlineCode>{props.text}</InlineCode>
			{!props.is_disabled && (
				<div className="relative">
					<i className="fas fa-copy" />
					{show_copied && (
						<div className="absolute -left-full -top-full text-sesh-primary opacity-80">
							<div className="">copied</div>
						</div>
					)}
				</div>
			)}
		</button>
	);
}
